
/**
 * Color predefinido para usar en componentes Ionic.
 */
enum Color {
  None      = 'none',
  Primary   = 'primary',
  Secondary = 'secondary',
  Tertiary  = 'tertiary',
  Success   = 'success',
  Warning   = 'warning',
  Danger    = 'danger',
  Light     = 'light',
  Medium    = 'medium',
  Dark      = 'dark',
}

export default Color;
